/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Vietnamese (Vietnam)
export default {
  'confluence-table-tree.column.contributors': 'Người đóng góp',
  'confluence-table-tree.column.last-modified': 'Sửa đổi gần đây nhất',
  'confluence-table-tree.column.title': 'Tên',
  'confluence-table-tree.could-not-load': 'Không tải được',
  'confluence-table-tree.could-not-load-contributors': 'Không tải được thông tin về những người đóng góp',
  'confluence-table-tree.create-child-page': 'Tạo trang con',
  'confluence-table-tree.create-page': 'Tạo trang',
  'confluence-table-tree.default.page.title': 'Chưa có tiêu đề',
  'confluence-table-tree.default.show-all-pages-button.label': 'Hiển thị nhiều trang hơn',
  'confluence-table-tree.draft.lozenge': 'BẢN NHÁP',
  'confluence-table-tree.draft.tooltip': 'Chỉ bạn mới có thể thấy bản nháp.',
  'confluence-table-tree.drafts-toggle.label': 'Hiển thị bản nháp',
  'confluence-table-tree.edit': 'Chỉnh sửa',
  'confluence-table-tree.edit-in-confluence': 'Sửa trong Confluence',
  'confluence-table-tree.empty.description':
    'Tạo vài ghi chú cuộc họp, yêu cầu sản phẩm, quyết định hoặc nội dung khác để thấy vùng này lấp đầy.',
  'confluence-table-tree.empty.title': 'Không có gì ở đây ngoài tiềm năng',
  'confluence-table-tree.error.description':
    'Chúng tôi không thể hiển thị cho bạn những trang này. Vui lòng thử lại sau.',
  'confluence-table-tree.error.row': 'Không thể tải trang.',
  'confluence-table-tree.error.title': 'Chà, thật là lạ...',
  'confluence-table-tree.friendly-when-created': 'Đã tạo',
  'confluence-table-tree.friendly-when-updated': 'Đã cập nhật',
  'confluence-table-tree.share.copied': 'Đã sao chép vào bảng nhớ tạm',
  'confluence-table-tree.share.copy-button': 'Sao chép',
  'confluence-table-tree.share.subtitle': 'Chia sẻ liên kết này',
  'confluence-table-tree.share.title': 'Chia sẻ trang',
  'confluence-table-tree.share.tooltip': 'Chia sẻ',
  'confluence-table-tree.view-profile': 'Xem hồ sơ',
};
